<template>
  <router-view class="insights"/>
</template>

<script>
import {authenticate} from '@/api/auth';
export default {
  name: 'App',
  metaInfo: {
    title: 'Ranker Insights'
  },
  async created() {
    await authenticate();
  }
};
</script>

